const styles = (theme) => ({
  flexRow: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
  },
  searchRow: {
    display: "flex",
    alignItems: "center",
  },
});

export default styles;
